export default "__VITE_ASSET__DMhCbmxE__"